import { useState, useEffect, useRef } from "react";
import axios from "axios";
import TableC from "../../features/table/Table";
import SideMenu from "../../features/sideMenu/SideMenu";
import Activo from "../../assets/img/svg/providers/installersIconGreen.svg";
import Inactivo from "../../assets/img/svg/providers/installersIconRed.svg";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import Restablecer from "../../assets/img/svg/users/restablecer.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import "./Installers.responsive.css";
import useConfirmDialog from "../../features/modal/ConfirmDialog";
import {
  deleteInstallerContact,
  fetchInstallers,
  fetchPerfiles,
} from "../functions/Functions";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { itemsProviders } from "../../constants/providers";
import { ClickAwayListener, Popper } from "@mui/material";

const Installers = ({ API_URL }) => {
  const [data, setData] = useState([]);
  const [dataOriginal, setDataOriginal] = useState([]);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [perfiles, setPerfiles] = useState([]); // Almacenar perfiles
  const [activeSelectIndex, setActiveSelectIndex] = useState(null);
  const [installers, setInstallers] = useState([]);
  const rowIconRef = useRef([]); // Ref único para cada fila
  const statusBtnRef = useRef({});
  const confirmDialog = useConfirmDialog();

  const { empresaId } = useParams();
  const navigate = useNavigate();
  const editarInstalador = async (id) => {
    navigate(`/proveedores/instaladores/editar/${id}`);
  };

  const eliminarInstalador = async (id, nombre) => {
    confirmDialog({
      html: `¿Estás seguro de que deseas eliminar el instalador <b>${nombre}</b>?`,
      icon: "warning",
      iconHtml: "!",
      confirmButtonText: "Sí, eliminar",

      cancelButtonText: "Cancelar",
      mostrarCancelar: true,
      iconClass: "swal2-warning",
      onConfirm: async () => {
        try {
          await deleteInstallerContact(API_URL, id);
          const updatedInstallers = await fetchInstallers(API_URL, empresaId);
          setInstallers(updatedInstallers);
          setData(updatedInstallers);
          confirmDialog({
            html: "El instalador fue eliminado con éxito.",
            icon: "success",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        } catch (error) {
          confirmDialog({
            html: `Ocurrió un error al eliminar la empresa.<br>${
              error.response?.data?.message || error.message
            }`,
            icon: "error",
            confirmButtonText: "Aceptar",
            mostrarCancelar: false,
          });
        }
      },
    });
  };

  const documentosInstalador = async (id) => {
    navigate(`/proveedores/instaladores/documentos/${id}`);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedInstallers = await fetchInstallers(API_URL, empresaId);
        const sortedInstallers = [...fetchedInstallers].sort((a, b) =>
          a.nombre.localeCompare(b.nombre)
        );
        setInstallers(sortedInstallers);
        setData(sortedInstallers);
        setDataOriginal(sortedInstallers);
      } catch (error) {
        console.error("Error al cargar los datos del usuario:", error);
      }
    };

    fetchData();
  }, [API_URL, empresaId]);

  useEffect(() => {
    fetchPerfiles(API_URL, setPerfiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isOn, setIsOn] = useState(false);
  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const toggleSelect = (index) => {
    setActiveSelectIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const enableInstaller = async (userId, name) => {
    confirmDialog({
      html: `<p class="text-dialog">${name} será activado. Podrás cambiar su estatus en cualquier momento.</p>`,
      icon: "success",
      iconHtml: "!",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      onConfirm: async () => {
        try {
          await axios
            .post(
              `${API_URL}/api/contactos-instaladores/habilitar-contacto-instalador`,
              {},
              {
                params: { id: userId },
                withCredentials: true,
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((result) => {
              if (result.status === 200) {
                window.location.href = window.location.href;
              }
            });
        } catch (error) {
          console.error("Error al habilitar usuario:", error);
        }
      },
    });
  };

  const disableInstaller = (userId, name) => {
    confirmDialog({
      html: `<p class="text-dialog">${name} será inhabilitado. Podrás cambiar su estatus en cualquier momento.</p>`,
      icon: "warning",
      iconHtml: "!",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      onConfirm: async () => {
        try {
          await axios
            .post(
              `${API_URL}/api/nxt/contactos-instaladores/deshabilitar-contacto-instalador`,
              {},
              {
                params: { id: userId },
                withCredentials: true,
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((result) => {
              if (result.status === 200) {
                window.location.href = window.location.href;
              }
            });
        } catch (error) {
          console.error("Error al habilitar usuario:", error);
        }
      },
    });
  };

  const columns = [
    {
      Header: "Nombre de instalador",
      accessor: "lol",
      width: 150,
      Cell: ({ row }) => {
        const nombre = row.original.nombre || "Sin nombre";
        const apellidos = row.original.apellidos || "Sin apellidos";
        const capitalize = (text) =>
          text
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");

        return `${capitalize(nombre)} ${capitalize(apellidos)}`;
      },
    },
    {
      Header: "Gafete",
      accessor: "numGafete",
      width: 130,
    },
    {
      Header: "Por defecto",
      accessor: "porDefecto",
      width: 100,
      Cell: ({ value }) => (value ? "✅" : "❌"),
    },
    {
      Header: "Perfil",
      accessor: "perfilInstalador.nombre",
      width: 130,
      Cell: ({ value }) => {
        if (!value) return "";
        const formattedValue =
          value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

        return <>{formattedValue}</>;
      },
    },
    {
      Header: "Estatus",
      accessor: "habilitado",
      width: 100,
      Cell: ({ value, row }) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {/* Botón/ícono que abre el popover de estatus */}
          <img
            ref={(el) => (statusBtnRef.current[row.index] = el)}
            src={value ? Activo : Inactivo}
            alt={value ? "Activo" : "Inactivo"}
            style={{ width: 20, height: 20, cursor: "pointer" }}
            onClick={() => {
              // alterna este popover y cierra el de acciones
              setActiveSelectIndex((prev) =>
                prev === row.index ? null : row.index
              );
              setOpenMenuIndex(null);
            }}
          />

          {/* Popper para el popover de estatus */}
          <Popper
            open={activeSelectIndex === row.index}
            anchorEl={statusBtnRef.current[row.index]}
            placement="bottom-start"
            style={{ zIndex: 1302 }}
          >
            <ClickAwayListener onClickAway={() => setActiveSelectIndex(null)}>
              <div
                style={{
                  position: "static",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  fontFamily: "nunito",
                  fontSize: "14px",
                }}
              >
                <div
                  style={{
                    padding: "6px 8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => {
                    setActiveSelectIndex(null);
                    enableInstaller(data[row.index].id, data[row.index].nombre);
                  }}
                >
                  <img
                    src={Activo}
                    alt="Activo"
                    style={{ width: 20, height: 20 }}
                  />
                  Activo
                </div>

                <div
                  style={{
                    padding: "6px 8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                  onClick={() => {
                    setActiveSelectIndex(null);
                    disableInstaller(
                      data[row.index].id,
                      data[row.index].nombre
                    );
                  }}
                >
                  <img
                    src={Inactivo}
                    alt="Inactivo"
                    style={{ width: 20, height: 20 }}
                  />
                  Inhabilitado
                </div>
              </div>
            </ClickAwayListener>
          </Popper>
        </div>
      ),
    },
    {
      Header: " ",
      width: 50,
      Cell: ({ row }) => {
        return (
          <div style={{ position: "relative" }}>
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={() => {
                // alterna este menú y cierra el popover de estatus
                setOpenMenuIndex((prev) =>
                  prev === row.index ? null : row.index
                );
                setActiveSelectIndex(null);
              }}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: 20, height: 20 }}
              />
            </button>

            {/* Popper para el menú de acciones */}
            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 1302 }}
            >
              <ClickAwayListener onClickAway={() => setOpenMenuIndex(null)}>
                <div
                  className="dropdown-menu-user"
                  style={{
                    position: "static",
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: 8,
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    padding: 10,
                    minWidth: 200,
                  }}
                >
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      documentosInstalador(data[row.index]?.id);
                    }}
                  >
                    <img src={Restablecer} alt="" /> Cargar documentos
                  </p>

                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      documentosInstalador(data[row.index]?.id);
                    }}
                  >
                    <img src={Restablecer} alt="" /> Ver documentos
                  </p>

                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      editarInstalador(data[row.index]?.id);
                    }}
                  >
                    <img src={Editar} alt="" /> Editar datos
                  </p>

                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setOpenMenuIndex(null);
                      eliminarInstalador(
                        data[row.index]?.id,
                        data[row.index]?.nombre
                      );
                    }}
                  >
                    <img src={Eliminar} alt="" /> Eliminar instalador
                  </p>
                </div>
              </ClickAwayListener>
            </Popper>
          </div>
        );
      },
    },
  ];

  const fields = [
    { name: "nombreInstalador", label: "Nombre de instalador" },
    { name: "numGafete", label: "Gafete" },
    { name: "buscarInhabilitados", label: "¿Buscar deshabilitados?" },
  ];

  return (
    <div
      className="installers-container"
      style={{ display: "flex", width: "100%" }}
    >
      <div className="installers-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProviders} />
      </div>
      {/* Contenedor inferior */}
      <div
        className="installers-main"
        style={{ flex: 1, padding: "10px", width: "100%" }}
      >
        <div className="installers-tableWrap">
          <TableC
            data={installers}
            dataOriginal={dataOriginal}
            setData={setData}
            columns={columns}
            rowsPerPage={6}
            url={"contactos-instaladores"}
            fields={fields}
            perfiles={perfiles}
            isOn={isOn}
            setIsOn={setIsOn}
            width={"252px"}
            height={"21px"}
            setFilteredBase={setInstallers}
            navigateBTNew={`/proveedores/instaladores/nuevo/${empresaId}`}
          />
        </div>
      </div>
    </div>
  );
};

export default Installers;
